import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store';

import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import Datepicker from "@vuepic/vue-datepicker";

import "bootstrap";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import "@vuepic/vue-datepicker/dist/main.css";
import "@/assets/scss/app.scss";

import { Enums } from "@/helpers/enums";
import { Links } from "@/helpers/links";
import { Constants } from "@/helpers/constants";
import { appData, C, Text, D, J, Rnd } from "./helpers/global";
import { SupportType, MethodType, Web, Msg, Popup, Wait, Ajax, Exporter, Animation } from "./helpers/web";

import FormControl from "@/components/FormControl.vue";
import FilterControl from "@/components/FilterControl.vue";
import CurrencyUnit from "@/components/CurrencyUnit.vue";
import SmartTable from "@/components/SmartTable.vue";
import AjaxSmartTable from "./components/AjaxSmartTable.vue";
import ExportButtons from "@/components/ExportButtons.vue";
import SmartModal from "@/components/SmartModal.vue";
import TabPanel from "@/components/TabPanel.vue";

const globalProperties = {
    Enums, Links, Constants,
    appData, C, Text, D, J, Rnd,
    SupportType, MethodType, Web, Msg, Popup, Wait, Ajax, Exporter, Animation,
    $error(page, ex) { router.push({ name: "error", params: { page: page, msg: ex.message } }); },
    $go(link) { if (link) { router.push(link); } },
    $copy(event) { if (event) { try { Web.ClipboardText(event.currentTarget.innerText, false); } catch (e) { console.error(e); } } },
    $copyStyle(event) { if (event) { try { Web.ClipboardStyleText(event.currentTarget, false); } catch (e) { console.error(e); } } },
    $copyHtml (event) { if (event) { try { Web.ClipboardText(event.currentTarget.innerHTML, false); } catch (e) { console.error(e); } } },
};

window.$table = SmartTable.init;
window.$tableAjax = AjaxSmartTable.init;

var app = createApp(App);
app.config.globalProperties = { ...app.config.globalProperties, ...globalProperties };
app
    .use(router)
    .use(store)
    .use(VueAxios, axios)
    .use(VueSweetalert2)
    .use(PerfectScrollbar)
    .component("Datepicker", Datepicker)
    .component("c", FormControl)
    .component("f", FilterControl)
    .component("currency", CurrencyUnit)
    .component("smart-table", SmartTable)
    .component("ajax-smart-table", AjaxSmartTable)
    .component("export-buttons", ExportButtons)
    .component("modal", SmartModal)
    .component("tabs", TabPanel)
    .mount("#app");